import { render, staticRenderFns } from "./PoisDetail.vue?vue&type=template&id=eea893b8&scoped=true&"
import script from "./PoisDetail.vue?vue&type=script&lang=js&"
export * from "./PoisDetail.vue?vue&type=script&lang=js&"
import style0 from "./PoisDetail.vue?vue&type=style&index=0&id=eea893b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eea893b8",
  null
  
)

export default component.exports